import React from 'react';
import Modal from 'components/Modal';
import { observer } from 'mobx-react';
import { Form } from 'components/Form';
import { Dialog, DialogContent, DialogFooter, DialogButton } from 'components/Dialog';
import Button from 'components/Button';
import ResponseInput from '../ResponseInput';
import ResponseImage from '../ResponseImage';
import styles from './PromptDialog.m.sass';
var PromptDialog = observer(function (_ref) {
  var _store$prompt, _store$prompt$questio, _store$prompt$questio2;
  var store = _ref.store;
  if (!store.prompt) {
    return null;
  }
  var canAnswer = store.canAnswer;
  var canDelete = store.canDelete;
  var type = store.prompt.question.type;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpened: store.showing,
    onRequestClose: store.hide
  }, /*#__PURE__*/React.createElement(Dialog, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: store.save
  }, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    className: styles.promptDialog,
    "data-test": 'prompt-dialog-type-' + type
  }, /*#__PURE__*/React.createElement(ResponseImage, {
    vm: store.prompt.question
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.title,
    "data-test": "prompt-dialog-title"
  }, (_store$prompt = store.prompt) === null || _store$prompt === void 0 ? void 0 : (_store$prompt$questio = _store$prompt.question) === null || _store$prompt$questio === void 0 ? void 0 : _store$prompt$questio.question), /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle,
    "data-test": "prompt-dialog-description"
  }, (_store$prompt$questio2 = store.prompt.question) === null || _store$prompt$questio2 === void 0 ? void 0 : _store$prompt$questio2.description), /*#__PURE__*/React.createElement(ResponseInput, {
    vm: store,
    disabled: !canAnswer,
    onChange: store.setAnswer
  }))), /*#__PURE__*/React.createElement(DialogFooter, {
    bordered: true
  }, canAnswer ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    type: "default",
    onClick: store.hide,
    dataTest: "prompt-close-button"
  }, "Not Now"), /*#__PURE__*/React.createElement(DialogButton, {
    submit: store.save,
    primary: true,
    dataTest: "prompt-submit-button",
    disabled: !store.canSubmit
  }, "Submit")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: styles.promptCompleted
  }, store.completedDescription), /*#__PURE__*/React.createElement(Button, {
    type: "default",
    onClick: store.hide,
    dataTest: "prompt-close-button"
  }, "Close")), canDelete && /*#__PURE__*/React.createElement(Button, {
    onClick: store.showDeleteDialog,
    type: "danger",
    dataTest: "prompt-submit-button"
  }, "Delete")))), /*#__PURE__*/React.createElement(PromptDeleteDialog, {
    store: store
  }));
});
var PromptDeleteDialog = observer(function (_ref2) {
  var store = _ref2.store;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpened: store.showingDeleteDialog,
    onRequestClose: store.hideDeleteDialog
  }, /*#__PURE__*/React.createElement(Dialog, null, /*#__PURE__*/React.createElement(Form, {
    onSubmit: store.delete
  }, /*#__PURE__*/React.createElement(DialogContent, null, /*#__PURE__*/React.createElement("div", {
    className: styles.promptDialog,
    "data-test": 'delete-dialog'
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.deletePromptImage,
    src: require('assets/img/img_missing-permissions.svg')
  }), /*#__PURE__*/React.createElement("h2", {
    className: styles.title,
    "data-test": "delete-dialog-title"
  }, "Are you sure you want to delete this prompt?"), /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle,
    "data-test": "delete-dialog-description"
  }, "This action cannot be undone. Are you sure that you want to permanently delete this prompt?"))), /*#__PURE__*/React.createElement(DialogFooter, {
    bordered: true
  }, /*#__PURE__*/React.createElement(DialogButton, {
    submit: store.delete,
    danger: true,
    dataTest: "delete-submit-button"
  }, "Delete Forever"), /*#__PURE__*/React.createElement(Button, {
    type: "default",
    onClick: store.hideDeleteDialog,
    dataTest: "delete-close-button"
  }, "Close")))));
});
export default PromptDialog;
//# sourceMappingURL=index.js.map
